import Vue from 'vue'
import * as groupHttp from './utils/http'
import { getGroupAuthorization } from './utils/auth'
import './filters/type'

let installed = false
let cubeUiLoading = null
let cubeUiInstalled = false
let groupLoadingInstance = null

function loadStyle (href) {
  if (document.querySelector(`link[href="${href}"]`)) {
    return
  }
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href
  document.head.appendChild(link)
}

function loadScript (src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = src
    script.onload = resolve
    script.onerror = reject
    document.head.appendChild(script)
  })
}

export function ensureCubeUi () {
  if (Vue.prototype.$createToast || installCubeUiFromGlobal()) {
    return Promise.resolve()
  }
  if (!cubeUiLoading) {
    loadStyle('https://unpkg.com/cube-ui/lib/cube.min.css')
    cubeUiLoading = loadScript('https://unpkg.com/cube-ui/lib/cube.min.js').then(() => {
      if (!installCubeUiFromGlobal()) {
        throw new Error('cube-ui 加载失败')
      }
    })
  }
  return cubeUiLoading
}

function getCubePlugin () {
  if (!window.cube) return null
  return window.cube.default || window.cube
}

function installCubeUiFromGlobal () {
  if (Vue.prototype.$createToast) {
    cubeUiInstalled = true
    return true
  }
  if (cubeUiInstalled) return true

  const cubePlugin = getCubePlugin()
  if (!cubePlugin || typeof cubePlugin.install !== 'function') {
    return false
  }

  Vue.use(cubePlugin)
  cubeUiInstalled = !!Vue.prototype.$createToast
  return cubeUiInstalled
}

function createToastFallback (type) {
  return function (content) {
    if (this.$createToast) {
      const toast = this.$createToast({
        txt: content,
        time: 1000,
        type
      })
      toast.show()
      return
    }
    if (this.$toast) {
      this.$toast({
        message: content
      })
      return
    }
    alert(content)
  }
}

function createConfirmFallback () {
  return function (options) {
    if (this.$createDialog) {
      this.$createDialog({
        type: 'confirm',
        title: options.title,
        content: options.content,
        confirmBtn: {
          text: '确定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          options.success && options.success()
        },
        onCancel: () => {}
      }).show()
      return
    }
    if (window.confirm(options.content || options.title)) {
      options.success && options.success()
    }
  }
}

function createLoadingFallback () {
  return {
    show () {},
    hide () {}
  }
}

export function installGroupRuntime () {
  if (installed) return
  installed = true

  Vue.prototype.$groupGet = groupHttp.get
  Vue.prototype.$groupPost = groupHttp.post
  Vue.prototype.$hasGroupAuthorization = getGroupAuthorization
  Vue.prototype.$groupImgHost = `${location.protocol}//image.daishupei.com/`
  Vue.prototype.$groupLoading = function () {
    if (this.$createToast) {
      if (!groupLoadingInstance) {
        groupLoadingInstance = this.$createToast({
          time: 0,
          mask: true
        })
      }
      return groupLoadingInstance
    }
    return createLoadingFallback()
  }
  if (!Vue.prototype.$success) {
    Vue.prototype.$success = createToastFallback('success')
  }
  if (!Vue.prototype.$warn) {
    Vue.prototype.$warn = createToastFallback('warn')
  }
  if (!Vue.prototype.$error) {
    Vue.prototype.$error = createToastFallback('error')
  }
  if (!Vue.prototype.$confirm) {
    Vue.prototype.$confirm = createConfirmFallback()
  }
}



// WEBPACK FOOTER //
// ./src/group/bootstrap.js